// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textField {
  width: 100%;
  padding-bottom: 20px !important;
}

.selectField {
  width: 100%;
  padding-bottom: 0px !important;
}

.buttonField {
  width: 100%;
  font-size: 9px !important;
}

.labelText > * {
  font-size: 20px;
  color: gray;
}

.spanText {
  font-size: 22px;
  font-weight: bold;
  color: gray;
}

.lcContainer {
  display: flex;
  padding: 20px;
  margin: 20px;
  align-items: left;
  justify-content: left;
  width: 100%;
  font-size: 20px;
  color: gray;
}

.lcContainerChildFirst {
  width: 60%;
}

.lcContainerChild2nd {
  height: 30px;
  margin-left: 20px !important;
  flex-basis: 10%;
}

.lcWrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  margin: 20px;
  width: 100%;
  font-size: 22px;
  font-weight: bold;
  color: gray;
  width: 90%;
}

.lcWrapperChild {
  padding-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/stripe/Checkout.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,+BAAA;AACJ;;AAEA;EACI,WAAA;EACA,8BAAA;AACJ;;AAGA;EACI,WAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,eAAA;EACA,WAAA;AAAJ;;AAEA;EACI,eAAA;EACA,iBAAA;EACA,WAAA;AACJ;;AAGA;EACI,aAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AAAJ;;AAIA;EACI,UAAA;AADJ;;AAIA;EACI,YAAA;EACA,4BAAA;EACA,eAAA;AADJ;;AAIA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;AADJ;;AAIA;EACG,oBAAA;AADH","sourcesContent":[".textField{\n    width:100%;\n    padding-bottom: 20px!important;\n    \n}\n.selectField{\n    width:100%;\n    padding-bottom: 0px!important;\n    \n}\n\n.buttonField{\n    width:100%;\n    font-size: 9px!important;\n    \n}\n.labelText > *{\n    font-size: 20px;\n    color:gray;\n}\n.spanText{\n    font-size: 22px;\n    font-weight: bold;\n    color:gray;\n  \n}\n\n.lcContainer{\n    display:flex;\n    padding: 20px;\n    margin: 20px;\n    align-items: left;\n    justify-content: left;\n    width:100%;\n    font-size: 20px;\n    color:gray;\n}\n\n\n.lcContainerChildFirst{\n    width: 60%;\n}\n\n.lcContainerChild2nd{\n    height:30px;\n    margin-left:20px!important;\n    flex-basis: 10%;\n}\n\n.lcWrapper{\n    display:flex;\n    flex-direction:column;\n    padding: 20px;\n    margin: 20px;\n    width:100%;\n    font-size: 22px;\n    font-weight: bold;\n    color:gray;\n    width:90%;\n}\n\n.lcWrapperChild{\n   padding-bottom:10px;\n \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
